/* eslint-disable @typescript-eslint/no-explicit-any */
import { CouponType } from "../../constants";
import { customCouponValidationSchema } from "./CustomCoupon.schema";
import { influencerCouponValidationSchema } from "./InfluencerCoupon.schema";
import { ordersResoldCouponValidationSchema } from "./OrdersResoldCoupon.schema";
import { qtyResoldCouponValidationSchema } from "./QtyResoldCoupon.schema";
import { SASCouponValidationSchema } from "./SASCoupon.schema";
import { sharingsCouponValidationSchema } from "./SharingsCoupon.schema";
import { valueResoldCouponValidationSchema } from "./ValueResoldCoupon.schema";

export * from "./SASCoupon.schema";
export * from "./ValueResoldCoupon.schema";
export * from "./OrdersResoldCoupon.schema";
export * from "./CustomCoupon.schema";

export const couponValidationSchema: Record<CouponType, any> = {
  [CouponType.SharingCoupon]: sharingsCouponValidationSchema,
  [CouponType.QuantityResoldCoupon]: qtyResoldCouponValidationSchema,
  [CouponType.AmountResoldCoupon]: valueResoldCouponValidationSchema,
  [CouponType.OrdersResoldCoupon]: ordersResoldCouponValidationSchema,
  [CouponType.CustomCoupon]: customCouponValidationSchema,
  [CouponType.SpendAndSaveCoupon]: SASCouponValidationSchema,
  [CouponType.InfluencerCoupon]: influencerCouponValidationSchema
};
